import {LoanStatusType} from '../model/loan-status.model';

export class LoanUtil {

    public static getDisplayableLoanStatus(status: LoanStatusType, isRestructured: boolean, filledPercentage: number): string {
        const loanRestructuringStatus = isRestructured ? 'Restructured & ' : '';
        if (status === LoanStatusType.Accepted) {
            return 'Accepted';
        } else if (status === LoanStatusType.QueuedToBeFulfilled) {
            return 'Queued to be fulfilled';
        } else if ((status === LoanStatusType.Disbursed || status === LoanStatusType.DocumentHardcopyReceived) && filledPercentage >= 70) {
            return loanRestructuringStatus + 'Active';
        } else if (status === LoanStatusType.Fulfilled && filledPercentage >= 70) {
            return loanRestructuringStatus + 'Fulfilled';
        } else if (status === LoanStatusType.ClosedPrepayment) {
            return loanRestructuringStatus + 'Prepaid';
        } else if (status === LoanStatusType.LoanMatured) {
            return loanRestructuringStatus + 'Fully Repaid';
        } else if (status === LoanStatusType.SubStandardAsset) {
            return loanRestructuringStatus + 'Sub Standard Asset';
        } else if (status === LoanStatusType.LossAsset) {
            return loanRestructuringStatus + 'Loss Asset';
        } else if (status === LoanStatusType.ClosedSettlement) {
            return loanRestructuringStatus + 'Settled and Closed';
        } else if (status === LoanStatusType.Closed) {
            return loanRestructuringStatus + 'Closed before disbursal';
        } else {
            return Math.round(filledPercentage) + '% of loan filled';
        }
    }
}
